<template>
  <div id="app">
    <op-header></op-header>
    <div class="page-view"><router-view /></div>

    <op-footer></op-footer>
  </div>
</template>
<script>
import opHeader from "@/components/common/header.vue";
import opFooter from "@/components/common/footer.vue";
export default {
  data() {
    return {};
  },
  components: { opHeader, opFooter }
};
</script>

<style lang="less">
#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .page-view {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
